// src/hooks/useFileValidation.js
import { useTranslation } from '../i18n';

const MAX_FILE_SIZE = 15 * 1024 * 1024; // 15MB (matching your backend)
const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
const ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.pdf'];

export const useFileValidation = () => {
  const { t } = useTranslation();

  const validateFile = (file) => {
    const errors = [];

    // Check file size
    if (file.size && file.size > MAX_FILE_SIZE) {
      errors.push({
        code: 'FILE_TOO_LARGE',
        message: t('fileValidation.fileTooLarge', { 
          maxSize: '15MB',
          fileName: file.name || 'File'
        })
      });
    }

    // Check file type
    if (file.mimeType || file.type) {
      const fileType = file.mimeType || file.type;
      if (!ALLOWED_TYPES.includes(fileType)) {
        // Check extension as fallback
        const ext = file.name ? `.${file.name.split('.').pop()}`.toLowerCase() : '';
        if (!ALLOWED_EXTENSIONS.includes(ext)) {
          errors.push({
            code: 'INVALID_FILE_TYPE',
            message: t('fileValidation.invalidFileType', {
              fileName: file.name || 'File',
              allowedTypes: 'PDF, JPG, PNG'
            })
          });
        }
      }
    }

    return {
      isValid: errors.length === 0,
      errors
    };
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return {
    validateFile,
    formatFileSize,
    MAX_FILE_SIZE,
    ALLOWED_TYPES,
    ALLOWED_EXTENSIONS
  };
};